import { createBrowserHistory } from 'history';
import { routerMiddleware } from 'connected-react-router';
import { applyMiddleware, compose, createStore } from 'redux';
import thunkMiddleware from 'redux-thunk';
import promiseMiddleware from 'redux-promise-middleware';
import notificationMiddleware from './notification-middleware';
import createRootReducer from './ducks';

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const history = createBrowserHistory();

const middlewares = [
  thunkMiddleware,
  promiseMiddleware,
  notificationMiddleware,
  routerMiddleware(history),
];

let store;

export default function configureStore() {
  if (!store) {
    store = createStore(
      createRootReducer(history),
      composeEnhancers(applyMiddleware(...middlewares)),
    );
  }
  return { store };
}
